const locales = {
  en: {
    welcome: 'Welcome Back...!',
    app: 'Main Page',
    title: 'Title',
    superAdminDashboard: 'SuperAdmin Dashboard',

    //Sidebar Menu
    users: 'Users',
    usersCategory: 'Users Category',
    errorReports: 'Error Reports',
    shops: 'Shops',
    orders: 'Orders',
    units: 'Units',
    modules: 'Modules',
    tasks: 'Tasks',
    roles: 'Roles',
    regions: 'Regions',
    shipping: 'Shipping',
    booths: 'Booths',
    couponsCategory: 'Coupons Category',
    coupons: 'Coupons',
    products: 'Products',
    productShop: 'Product Shop',
    productsCategory: 'Products Category',
    productsUnits: 'Products Units',
    brands: 'Brands',
    attributes: 'Attributes',
    attributesCategory: 'Attributes Category',
    attributesValue: 'Attributes Value',
    TemporaryModel: 'Temporary',

    //Icons
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    refresh: 'Refresh',
    createBulk: 'Create Bulk',
    AssignRole: 'Assign Role',
    AssignGroup: 'Assign Group',
    fcm: 'Messaging',
    workTimes: 'Work Times',
    workDelay: 'Work Delay',
    workRegions: 'Work Regions',
    costs: 'Costs',
    typeConditions: 'Type Conditions',
    ManagementInfo: 'Management Info',
    sendOrderOptions: 'Send Order Options',
    CheckShop: 'Check Shop',

    //Diaolgs
    userGroups: 'User Groups',
    userRoles: 'User Roles',

    //Toast
    selectItems: 'Please select items!',
  },
  fa: {
    welcome: 'خوش آمدید...!',
    app: 'صفحه اصلی',
    title: 'عنوان',
    superAdminDashboard: 'داشبورد مدیر کل',

    //Sidebar Menu
    users: 'کاربران',
    usersCategory: 'دسته‌بندی کاربران',
    errorReports: 'گزارشات خطا',
    shops: 'فروشگاه‌ها',
    orders: 'سفارشات',
    units: 'واحدها',
    modules: 'ماژول‌ها',
    tasks: 'فعالیت‌ها',
    roles: 'نقش‌ها',
    regions: 'مناطق',
    shipping: 'حمل و نقل',
    booths: 'غرفه‌ها',
    couponsCategory: 'دسته‌بندی بن‌ها',
    coupons: 'بن‌ها',
    products: 'محصولات',
    productShop: 'محصولات فروشگاه',
    productsCategory: 'دسته‌بندی محصولات',
    productsUnits: 'واحدهای محصولات',
    brands: 'برندها',
    attributes: 'ویژگی‌ها',
    attributesCategory: 'دسته‌بندی ویژگی‌ها',
    attributesValue: 'مقادیر ویژگی‌ها',

    //Icons
    create: 'افزودن',
    update: 'ویرایش',
    delete: 'حذف',
    refresh: 'تازه‌سازی',
    createBulk: 'افزودن انبوه',
    AssignRole: 'تخصیص نقش',
    AssignGroup: 'تخصیص گروه',
    fcm: 'ارسال پیام',
    workTimes: 'زمان کاری',
    workDelay: 'تاخیر کاری',
    workRegions: 'مناطق کاری',
    costs: 'هزینه‌ها',
    typeConditions: 'شرایط و قوانین',
    ManagementInfo: 'مدیریت',
    sendOrderOptions: 'روش‌های ارسال',
    CheckShop: 'وضعیت فروشگاه',
    TemporaryModel: 'داده های موقت',

    //Diaolgs
    userGroups: 'گروه کاربر',
    userRoles: 'نقش کاربر',

    //Toast
    selectItems: 'لطفا موارد را انتخاب کنید!',

    //Forms
    activity: 'فعالیت',
    active: 'فعال',
    inactive: 'غیرفعال',
  },
};

export default locales;
